import Control from "../../../../../common/Controls/Control";
import RCPROPrestationsInternationales from "./RCPROPrestationsInternationales";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROAutreCommerce = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig } = useRCPROQuestion({
    company,
  });

  const activityKey = "autresCommerces";

  return (
    <div>
      <Control
        label={inputsConfig.autresCommercesTypeCommerce.label}
        type="checkBtnList"
        name="autresCommercesTypeCommerce"
        value={company.RCPRO.autresCommercesTypeCommerce}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.autresCommercesTypeCommerce.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
        info={<>Plusieurs réponses possibles.</>}
      />
      {company.RCPRO.autresCommercesTypeCommerce.includes(4) && (
        <Control
          label={inputsConfig.autresCommercesAutreTypeCommerce.label}
          type="text"
          name="autresCommercesAutreTypeCommerce"
          value={company.RCPRO.autresCommercesAutreTypeCommerce}
          change={updateRcproData}
          error={errors}
          labelClassname="w-100"
          inputGroupStyle={{ width: "100%" }}
          onBlur={onBlur}
          required
        />
      )}
      <Control
        label={inputsConfig.autresCommercesLocalPhysique.label}
        type="btnList"
        name="autresCommercesLocalPhysique"
        value={company.RCPRO.autresCommercesLocalPhysique}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.autresCommercesLocalPhysique.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <RCPROPrestationsInternationales
        company={company}
        activityKey={activityKey}
      />
    </div>
  );
};

export default RCPROAutreCommerce;
